import type {
  StorefrontPreviewOrderRulesListParametersType,
  StorefrontPreviewOrderRulesListResponseType,
} from "@sellar-io/api-v2/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useStorefrontPreviewOrderRulesList = <
  TData = StorefrontPreviewOrderRulesListResponseType,
>(
  params: StorefrontPreviewOrderRulesListParametersType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.StorefrontPreviewOrderRules,
      params,
    ],
    queryFn: (queryParams) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "storefront-preview/order-rules",
        params: {
          ...params,
          offset: queryParams.pageParam,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultInfiniteQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: { ...options, limit: params.limit },
    }),
  });
};
